import { translate } from '@/domains/core/localization/translate';
export const {
  descriptionTitle,
  descriptionBlockTitle,
  descriptionBlockSeeLess,
  descriptionBlockSeeMore,
  descriptionBlockSeeAll
} = translate({
  "descriptionTitle": "Description",
  "descriptionBlockTitle": "Product details",
  "descriptionBlockSeeLess": "Show less",
  "descriptionBlockSeeMore": "Show more",
  "descriptionBlockSeeAll": "View all"
});